import {
  FiCheck,
  FiEdit,
  FiMinusCircle,
  FiPlus,
  FiPlusCircle,
  FiRefreshCw,
  FiUser,
  FiUserCheck,
  FiUserX,
  FiUsers,
  FiX,
} from "react-icons/fi";

import { EventLogAction } from "@/types/enums";

export const EVENT_LOG_CONFIG = {
  [EventLogAction.CREATED]: {
    label: "Created",
    color: "bg-status-success-bg text-status-success-text",
    icon: FiPlus,
  },
  [EventLogAction.CANCELLED]: {
    label: "Cancelled",
    color: "bg-status-error-bg text-status-error-text",
    icon: FiX,
  },
  [EventLogAction.RESCHEDULED]: {
    label: "Rescheduled",
    color: "bg-status-info-bg text-status-info-text",
    icon: FiRefreshCw,
  },
  [EventLogAction.STATUS_CHANGED]: {
    label: "Status Changed",
    color: "bg-status-warning-bg text-status-warning-text",
    icon: FiEdit,
  },
  [EventLogAction.CHECKED_IN]: {
    label: "Checked In",
    color: "bg-status-success-bg text-status-success-text",
    icon: FiUserCheck,
  },
  [EventLogAction.NO_SHOW_MARKED]: {
    label: "No Show",
    color: "bg-status-error-bg text-status-error-text",
    icon: FiUserX,
  },
  [EventLogAction.COMPLETED]: {
    label: "Completed",
    color: "bg-status-info-bg text-status-info-text",
    icon: FiCheck,
  },
  [EventLogAction.PATIENT_CHANGED]: {
    label: "Patient Changed",
    color: "bg-status-purple-bg text-status-purple-text",
    icon: FiUser,
  },
  [EventLogAction.PROVIDER_CHANGED]: {
    label: "Provider Changed",
    color: "bg-status-orange-bg text-status-orange-text",
    icon: FiUsers,
  },
  [EventLogAction.SERVICE_ADDED]: {
    label: "Service Added",
    color: "bg-status-success-bg text-status-success-text",
    icon: FiPlusCircle,
  },
  [EventLogAction.SERVICE_REMOVED]: {
    label: "Service Removed",
    color: "bg-status-error-bg text-status-error-text",
    icon: FiMinusCircle,
  },
} as const;

export const getEventLogConfig = (action: EventLogAction) => {
  return EVENT_LOG_CONFIG[action];
};
